import jwtDecode from "jwt-decode";
import React, { createContext, useState, useEffect } from "react";
import { role } from "../axious";
import { postMethodPermission } from "../services/httpServices";
import { accessMenu, accessOne } from "./config";
import { base_api_url, base_api_audit_url } from "../config";
import axios from "axios";
import { toast } from "react-toastify";

const Context = createContext("Default Value");

const getValidToken = () => {
  const stored = localStorage.getItem("token");
  if (!stored) return null;
  try {
    const decoded = jwtDecode(stored);
    if (decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      return null;
    }
    return stored;
  } catch (e) {
    localStorage.removeItem("token");
    return null;
  }
};

export function ContextProvider(props) {
  const [userAccess, setUserAccess] = useState(null);
  const [menu, setMenu] = useState(null);
  const [jwt, setJwt] = useState(getValidToken);
  const [isShowEditor, setIsShowEditor] = useState(false);
  const api1 = base_api_audit_url;
  const token = jwt;

  const handleApiError = (error) => {
    if (error && error.response && (error.response.status === 401 || error.response.status === 400)) return;
    error &&
      error.response &&
      error.response.data &&
      error.response.data.Message &&
      toast(error.response.data.Message);
    error &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.map(function(e) { return toast(e.msg); });
  };

  const getAudits = async () => {
    try {
      const { data: audits } = await axios.get(api1, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return audits;
    } catch (error) {
      handleApiError(error);
    }
  };

  const api = base_api_url;

  const getMethodPagination = async (route, page) => {
    const { data: collection } = await axios.get(api + route, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        page: page,
      },
    });
    return collection;
  };
  const getMethodPaginationWithFilter = async (route, page, filter) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: page,
          status: filter,
        },
      });
      return collection;
    } catch (error) {
      handleApiError(error);
    }
  };

  const getMethod = async (route) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return collection;
    } catch (error) {
      handleApiError(error);
    }
  };

  const getMethodSearch = async (
    route,
    searchQuery,
    searchType,
    statusType,
    dateType
  ) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route + searchQuery, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          searchBy: searchType,
          status: statusType,
          dateBy: dateType,
        },
      });
      return collection;
    } catch (error) {
      handleApiError(error);
    }
  };

  const putMethod = async (route, id, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, content, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };
  const putMethodSettings = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route, content, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };

  const putMethodFormData = async (route, id, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, content, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };

  const postMethod = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.post(api + route, content, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };
  const postMethodPermission = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.post(
        api + route + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };
  const postMethodNormal = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.post(api + route, content, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };
  const deleteMethod = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };
  const deleteMethod2 = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.delete(api + route + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          setJwt(null);
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  useEffect(() => {
    if (!jwt) return;
    try {
      const user = jwtDecode(jwt);
      axios
        .post(
          api + role.check + user.id,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setUserAccess(response.data.Message.Role);
        })
        .catch(function() {
          localStorage.removeItem("token");
          setJwt(null);
        });
    } catch (e) {
      localStorage.removeItem("token");
      setJwt(null);
    }
  }, [jwt]);

  useEffect(() => {
    try {
      const menuList = userAccess ? accessMenu(userAccess) : null;
      userAccess && menuList && setMenu(menuList);
    } catch (error) {
      console.log("Error: ", error);
    }
  }, [userAccess]);

  const context = {
    userAccess,
    menu,
    jwt,
    setJwt,
    getAudits,
    getMethodPagination,
    getMethodPaginationWithFilter,
    getMethod,
    getMethodSearch,
    putMethod,
    putMethodSettings,
    putMethodFormData,
    postMethod,
    postMethodPermission,
    postMethodNormal,
    deleteMethod,
    isShowEditor,
    setIsShowEditor,
    deleteMethod2,
  };
  return <Context.Provider value={context}>{props.children}</Context.Provider>;
}

export default Context;



// WEBPACK FOOTER //
// ./src/store/Context.js